import Loadable from 'react-loadable';
import Loading from '../components/Loading/LoadingPage';

const asyncWall = Loadable({
  loader: () => import('../pages/wall/wall.js'),
  loading: Loading,
  delay: 500
});
const asyncGroups = Loadable({
  loader: () => import('../pages/groups/groups.js'),
  loading: Loading,
  delay: 500
});
const asyncGroupDetail = Loadable({
  loader: () => import('../pages/groups/GroupDetail.js'),
  loading: Loading,
  delay: 500
});
const AsyncMessages = Loadable({
  loader: () => import('../pages/messages/messages.js'),
  loading: Loading,
  delay: 500
});
const asyncUsers = Loadable({
  loader: () => import('../pages/users/users.js'),
  loading: Loading,
  delay: 500
});
const asyncProfile = Loadable({
  loader: () => import('../pages/profile/profile.js'),
  loading: Loading,
  delay: 500
});
const asyncDocuments = Loadable({
  loader: () => import('../pages/documents/documents.js'),
  loading: Loading,
  delay: 500
});

export default [
  {
    path: '/wall',
    component: asyncWall,
    authenticated: true
  },
  {
    path: '/groups',
    component: asyncGroups,
    authenticated: true
  },
  {
    path: '/groups/:id',
    component: asyncGroupDetail,
    authenticated: true
  },
  {
    path: '/documents',
    component: asyncDocuments,
    authenticated: true
  },
  {
    path: '/messages',
    component: AsyncMessages,
    authenticated: true
  },
  {
    path: '/users',
    component: asyncUsers,
    authenticated: true
  },
  {
    path: '/profile',
    component: asyncProfile,
    authenticated: true
  }
];



// WEBPACK FOOTER //
// ./src/routes/AuthenticatedRoutes.js